module.exports = __webpack_public_path__ + "img/main-desktop.fcf3f70.webp";